// extracted by mini-css-extract-plugin
var _1 = "app-module__body--L2FwcC";
export { _1 as "body" }
